/*
 * @Author: Chao Yang
 * @Date: 2019-12-11 09:49:01
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-06-28 14:15:01
 */
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { InfrastructureModule } from 'src/app/infrastructure';
import { AccountProxy, BankingAccountProxy, DetailProxy } from './account';
import { ActivityProxy } from './activity';
import { DocumentProxy } from './document';
import { FolderProxy } from './folder';
import { FundProxy } from './fund';
import { LayoutProxy } from './layout';
import { PreferenceProxy } from './preference';
import { OfferingProxy } from './offering/offering.proxy';
import { OnboardingProxy } from './offering/onboarding.proxy';
import { TaskProxy } from './task';
import {
  MyInvestmentProxy,
  ConfigurationProxy,
  AggregateDataProxy,
  DashboardProxy,
} from './dashboard';
import { CommonProxy } from './common/common.proxy';
import { PositionProxy } from './portfolio';
import { SessionProxy } from './session';
import { TransferStationProxy } from './transferStation/transferStation.proxy';
import { DataRoomEditorProxy } from './offering/data-room-editor.proxy';
import { DataRoomProxy } from './offering/data-room.proxy';
import { MenuProxy } from './menu/menu.proxy';
import { FundTransactionProxy } from './fund/fundTransaction.proxy';
// import { FeatureDrillDownInvestorTransactionProxy } from './feature/index';
import { DocumentViewerProxy } from './document-viewer/document-viewer.proxy';
import { BrandProxy } from './brand/index';
import { UserActionTrackerProxy } from './user-action-tracker/user-action-tracker.proxy';

@NgModule({
  declarations: [],
  imports: [CommonModule, HttpClientModule, InfrastructureModule],
  providers: [
    AccountProxy,
    BankingAccountProxy,
    ActivityProxy,
    DatePipe,
    DetailProxy,
    DocumentProxy,
    FolderProxy,
    FundProxy,
    LayoutProxy,
    PreferenceProxy,
    OfferingProxy,
    TaskProxy,
    MyInvestmentProxy,
    ConfigurationProxy,
    AggregateDataProxy,
    DashboardProxy,
    CommonProxy,
    PositionProxy,
    SessionProxy,
    TransferStationProxy,
    OnboardingProxy,
    DataRoomEditorProxy,
    DataRoomProxy,
    MenuProxy,
    FundTransactionProxy,
    DocumentViewerProxy,
    BrandProxy,
    UserActionTrackerProxy
  ],
})
export class ProxyModule { }
